import { getInitialStateFromConfig } from "helpers/form";

const config = {
    firstName: {
        // field
        label: "Имя",
        inputProps: { name: "firstName" },
    },
    lastName: {
        // field
        label: "Фамилия",
        inputProps: { name: "lastName" },
    },
    patronymic: {
        // field
        label: "Отчество",
        inputProps: { name: "patronymic" },
    },
    email: {
        // field
        label: "Эл. почта",
        inputProps: { name: "email" },
    },
    phoneNumber: {
        // field
        label: "Телефон",
        type: "phone",
        inputProps: { name: "phoneNumber" },
    },
    phoneNumberExtension: {
        // field
        label: "Доб. номер",
        inputProps: { name: "phoneNumberExtension" },
    },
    twoFactorProvider: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
